import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5877a97f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full flex" }
const _hoisted_2 = {
  style: {"flex":"1 0 auto"},
  class: "license-page--container"
}
const _hoisted_3 = { class: "license-page--side-view" }
const _hoisted_4 = { class: "license-page--content shadowboxing" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'license-layout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { style: {"width":"100%"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "sideView")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "content")
          ])
        ])
      ])
    ]),
    _: 3
  }))
}
}

})